export const screenWrapperSx = {
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  padding: 2,
};
